import Logger from './logger';
import event from './mixins/event';
import { gsap } from "gsap";
import { Observer } from 'gsap/Observer';

gsap.registerPlugin(Observer);

class ThemeHeader {

	// Vars
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

	/**
	 * Class constructor
	 */
	constructor(dom) {

		this.NAME = 'ThemeHeader';

		this.dom = dom;

		this.displayModes = {
			normal: `theme-header`,
			transparentWhite: `theme-header theme-header--transparent-white`,
		};

		this.themeHeaderBrandingDom = this.dom.querySelector(`[data-theme-header-branding]`);
		this.themeHeaderBrandingActiveClass = `theme-header-branding--active`;

		this.themeHeaderHamburgerDom = this.dom.querySelector(`[data-theme-header-hamburger]`);
		this.themeHeaderHamburgerActiveClass = `theme-header__hamburger--active`;
		this.themeHeaderHamburgerBlendClass = `theme-header__hamburger--blend`;

		this.themeHeaderMobileNavDom = this.dom.querySelector(`[data-theme-header-mobile-nav]`);
		this.themeHeaderMobileNavActiveClass = `theme-header-mobile-nav--active`;
	}

	/**
	 * init - Initialize the form
	 */
	init() {
		Logger.info(`${this.NAME} > init`);
		this.initHamburger();
		this.initLogoAnimation();
	}

	/**
	 * initHamburger - Initialize the hamburger menu
	 */
	initHamburger() {
		Logger.info(`${this.NAME} > initHamburger`);

		this.themeHeaderHamburgerDom.addEventListener(`click`, (e) => {
			e.preventDefault();
			this.themeHeaderHamburgerDom.classList.toggle(this.themeHeaderHamburgerActiveClass);
			this.themeHeaderMobileNavDom.classList.toggle(this.themeHeaderMobileNavActiveClass);

			// Toggle no-scroll class on body
			if (this.themeHeaderHamburgerDom.classList.contains(this.themeHeaderHamburgerActiveClass)) {
				// Send `make-no-scroll` event to document
				document.dispatchEvent(new CustomEvent(`make-no-scroll`, { detail: { target: this.themeHeaderMobileNavDom } }));
			} else {
				// Send `remove-no-scroll` event to document
				document.dispatchEvent(new CustomEvent(`remove-no-scroll`, { detail: { target: this.themeHeaderMobileNavDom } }));
			}
		});
	}

	/**
	 * initLogoAnimation - Initialize the logo animation
	 */
	initLogoAnimation() {
		Logger.info(`${this.NAME} > initLogoAnimation`);

		const observer = Observer.create({
			target: document.body,
			type: `wheel,touch,scroll`,
			onChangeY: (self) => {
				if (self.scrollY() > 100) {
					this.themeHeaderBrandingDom.classList.add(this.themeHeaderBrandingActiveClass);
					this.themeHeaderHamburgerDom.classList.add(this.themeHeaderHamburgerBlendClass);
				} else {
					this.themeHeaderBrandingDom.classList.remove(this.themeHeaderBrandingActiveClass);
					this.themeHeaderHamburgerDom.classList.remove(this.themeHeaderHamburgerBlendClass);
				}
			}
		});

	}

	/**
	 * setDisplayMode - Set the display mode
	 */
	setDisplayMode(mode) {
		Logger.info(`${this.NAME} > setDisplayMode`);

		switch (mode) {
			case `transparentWhite`:
				this.dom.setAttribute(`class`, this.displayModes.transparentWhite);
				break;
			case `normal`:
			default:
				this.dom.setAttribute(`class`, this.displayModes.normal);
				break;
		}
	}

}

Object.assign(ThemeHeader.prototype, event);

export default ThemeHeader;
